const mixin = {
  props: {
    fireType: {
      type: String,
      default: () => {
        return "";
      }
    }
  },
  data() {
    return {
      timeH: "",
      timeM: "",
      respondText: "",
      fireTypeList: [
        {
          name: "复位",
          value: 40114
        },
        {
          name: "配置改变",
          value: 40113
        },
        {
          name: "手动状态",
          value: 40112
        },
        {
          name: "总线故障",
          value: 40111
        },
        {
          name: "备电故障",
          value: 40110
        },
        {
          name: "主电故障",
          value: 40109
        },
        {
          name: "反馈",
          value: 40107,
          value2: 40121
        },
        {
          name: "启动",
          value: 40106,
          value2: 40120
        },
        {
          name: "监管",
          value: 40105,
          value2: 40119
        },
        {
          name: "屏蔽",
          value: 40104,
          value2: 40118
        },
        {
          name: "故障",
          value: 40103,
          value2: 40117
        },
        {
          name: "火警",
          value: 40102,
          value2: 40116
        },
        {
          name: "运行状态",
          value: 40101,
          value2: 40115
        },
        {
          name: "电源故障",
          value: 40123
        }
      ]
    };
  },
  mounted() {
    this.getTime();
    this.timer = setInterval(() => {
      this.getTime();
    }, 5000);
    // this.addClick();
    // this.showFireType();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // text-按键名称，value:按键value值
    handleCheckClick(text, value) {
      this.$emit("controlCallBack", text, value);
    },
    getTime() {
      let time = new Date();
      let hour = time.getHours();
      let minutes = time.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      this.timeH = hour;
      this.timeM = minutes;
    },
    showFireType() {
      // 判断高亮类型
      let name = "";
      if (this.fireType) {
        this.fireTypeList.forEach((el) => {
          if (el.value == this.fireType || el.value2 == this.fireType) {
            name = el.name;
          }
        });
      }
      let checkAll = document.querySelectorAll(".checked");
      checkAll.forEach((el) => {
        if (el.nextSibling.innerHTML == name) {
          el.classList.toggle("rChecked");
        }
      });
    }
    // addClick() {
    //   let elClass = "";
    //   if (this.controlType == 2) {
    //     return;
    //     // elClass = '.f-btn'
    //   } else {
    //     elClass = ".ctl-btn";
    //   }
    //   let that = this;
    //   $(elClass).on("click", function () {
    //     // 点击样式
    //     let domList = document.querySelectorAll(elClass);
    //     domList.forEach((el) => {
    //       if (el.className.indexOf("checkedIng") > -1) {
    //         el.classList.toggle("checkedIng");
    //       }
    //     });
    //     this.classList.toggle("checkedIng");
    //     let ctlText = $(this).attr("name");
    //     console.log($(this).children);
    //     that.butClick(ctlText);
    //   });
    // },
    // onCheckCode(item) {
    // console.log(index, '888888888888888888index')
    // index || index === 0 ? this.$emit("controlCallBack", type, item, index) :
    // this.$emit("controlCallBack", item);
    // },
    // butClick(ctlText) {
    //   this.$emit("controlCallBack", ctlText);
    // }
  }
};
export default mixin;
